<template>
	<div class="mb-3">
		<label class="form-label small">{{ item.label }}</label>
		<input
			type="month"
			:value="item.value"
			@input="updateValue"
			class="form-control form-control-sm"
			:placeholder="item.placeholder"
		/>
	</div>
</template>

<script>
export default {
	name: 'MonthItem',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	methods: {
		updateValue(event) {
			this.$emit('update', event.target.value)
		},
	},
}
</script>
